<template>
  <v-app>
    <div class="gr-shell">
      <AppBar />

      <main class="gr-main">
        <slot />
      </main>

      <Footer />
    </div>
  </v-app>
</template>

<script lang="ts" setup>
// The masthead is imported eagerly: the first banner's URL has to be in the
// server-rendered document, so nothing above the hero may be async.
import AppBar from "./components/AppBar.vue";

const Footer = defineAsyncComponent(() => import("./components/Footer.vue"));
</script>

<style lang="scss" src="@/assets/styles/site.scss"></style>

<style>
/* The ground belongs to the shell so a short page never leaves a white band
   between the content and the footer. Public pages paint it again on
   `.gr-root`; the dashboard keeps its own container background on top. */
.gr-shell {
  background-color: var(--gr-paper);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.gr-main {
  flex: 1 0 auto;
}
</style>
